module.exports = __webpack_public_path__ + "static/media/press15.f3d3949f.png";